import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { CountryModel } from 'src/app/models/common/countrymodel';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { CurrencyMasterApiService } from 'src/app/services/domain_code/currency-master-api.service';
import { GeoApiService } from 'src/app/services/domain_code/geo-api.service';
import { AutoSearchService } from '../auto-search/auto-search.service';
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";
import { debounceTime, distinctUntilChanged, map, startWith, Subject } from "rxjs";
import { PhoneFieldService } from "./phone-field.service";
import { environment } from "../../../../environments/environment";

@Component({
    selector: 'app-phone-field',
    templateUrl: './phone-field.component.html',
    styleUrls: ['../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PhoneFieldComponent),
        }
    ]
})
export class PhoneFieldComponent extends BaseControlValueAccessor implements OnInit {

    @Input()
    stepValue: number = 0.01;

    @Input()
    minValue: number = Number.MIN_VALUE;

    @Input()
    maxValue: number = Number.MAX_VALUE;

    @Input()
    formFieldName = null;

    @Input()
    countryCodeFieldName = null;

    @Input()
    removeCross: boolean = true;

    @ViewChild('numberField')
    numberField;

    @Output()
    countryEmitter = new EventEmitter();

    searchText = new Subject<string>();
    loading = false;
    options: CountryModel[] = [];

    baseApiUrl = environment.baseApiUrl;

    selected_country: CountryModel;
    national_number: string;
    as_e164: string = null;

    countryPlaceholder = 'ISD';

    constructor(private geoService: GeoApiService,
        private autoSearchService: AutoSearchService) {
        super();
    }

    ngOnInit(): void {
        this.searchText.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            startWith(''),
            map(searchTerm => {
                this.setOptionList(searchTerm);

            })
        ).subscribe();
    }
    getDisplay() {
        if (this.as_e164 == null || this.as_e164 == undefined) {
            return '-';
        } else {
            return `${this.selected_country.isd_code}-${this.national_number}`
        }
    }

    data_cache = null;

    override get data() {
        return this._data;
    }

    override set data(val) {
        this._data = val;
        this.validate(val);
        if (val != null) {
            if (typeof val == 'object') {
                if ('as_e164' in val) {
                    this.as_e164 = val['as_e164'];
                }
                if ('country' in val) {
                    this.selected_country = val['country'];
                }
                if ('national_number' in val) {
                    this.national_number = val['national_number'];
                }
                this.errors = [];

                this.onChange(val);
            } else {
                this.resetFields();
                this.onChange(null);
            }
        } else {
            this.resetFields();
            this.onChange(null);
        }

    }

    resetFields() {
        this.as_e164 = null;
        this.selected_country = null;
        this.national_number = null;
        this.countryPlaceholder = 'ISD';
    }

    trackByFn(item) {
        return item.id;
    }

    compareField(options, idField) {
        return options === idField;
    }

    setOptionList(searchTerm) {

        this.loading = true;

        let url = new URL(ApiRoutes.Geo + 'country/');
        url.searchParams.append('search', searchTerm);

        this.autoSearchService.listObjects(String(url)).subscribe((response) => {
            this.loading = false;
            this.options = response.results;
        });
    }

    setFocusToNumber() {
        this.numberField.nativeElement.focus();
    }

    onCountryChange(country: CountryModel) {
        if (country != null) {
            if ('id' in country) {
                this.countryPlaceholder = null;
                this.selected_country = country;
                this.countryEmitter.emit(this.selected_country)
            }
        } else {
            this.countryPlaceholder = 'ISD';
            this.selected_country = null;
            this.countryEmitter.emit(this.selected_country)
        }
        this.setDataIfPossible()
    }

    onNumberChange(number: string) {
        if (number != null) {
            this.national_number = number;
        } else {
            this.national_number = null;
        }
        this.setDataIfPossible();
    }

    // setDataIfPossible() {
    //     if (this.selected_country != null && this.national_number != null) {
    //         this.as_e164 = this.selected_country.isd_code + this.national_number;
    //         this.data_cache = {
    //             'country': this.selected_country,
    //             'as_e164': this.as_e164,
    //             'national_number': this.national_number
    //         }
    //     }
    //
    //     if(this.data_cache != null) {
    //       if (this.data_cache['country'] && this.data_cache['national_number']) {
    //         this.data = {... this.data_cache};
    //         return;
    //       }
    //     }
    //     this.data = null;
    //
    // }

    setDataIfPossible() {
        if (this.selected_country != null && this.national_number != null) {
            this.as_e164 = this.selected_country.isd_code + this.national_number;
            this.data = {
                'country': this.selected_country,
                'as_e164': this.as_e164,
                'national_number': this.national_number
            }
            return;
        }
        if (this.selected_country != null && this.national_number == null) {
            this.data = {
                'country': this.selected_country,
                'as_e164': null,
                'national_number': null
            }
            return;
        }
        if (this.selected_country == null && this.national_number != null) {
            this.data = {
                'country': null,
                'as_e164': null,
                'national_number': this.national_number
            }
            return;
        }
    }

    override validate(val) {
        // if (val.country != null && val.national_number == null) {
        //     console.log("validate", val)
        //     // val = null;
        // } else {
        //     console.log("non empty ", val)
        // }
        return val
    }
}
